import { render } from "./Handbags.vue?vue&type=template&id=7bdba6a6"
import script from "./Handbags.vue?vue&type=script&lang=js"
export * from "./Handbags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__